export default __webpack_public_path__ + "static/spiralgap-3c7cb97fb0f8ce020b6156da6f1c3c19.png";